import React, { useState, useEffect, useCallback } from 'react';
import {  Button, Row, Col, Modal, Form, message, TimePicker,  Input, Tooltip, Select, Spin } from 'antd';
import dayjs from 'dayjs';
import {  replaceScheduleWorkmen, updateCrewAndEmployeeDetails } from '../../services/crew';
import { FilterOutlined } from "@ant-design/icons";
import MainStepper from './MainStepper';
import BasicDetails from './BasicDetails';
import LocationIcon from "../../../../src/assets/Location_Icon.svg"
import SettingIcon from "../../../../src/assets/Setting_Icon.svg";
import PeopleIcon from "../../../../src/assets/People_Icon.svg";
import TimerIcon from "../../../../src/assets/Timer_Icon.svg";
import SmartTable from './SmartTable';
import HOC from './HOC';
import useAuth from '../../hooks/useAuth';
import { fieldAutoSuggest } from "../../services/selfOnboarding";
import { getDetails } from '../../services/auth';
import ScheduleConflictHandler from './ScheduleConflictHandler';
import { RemoveFilters } from "./RemoveFilters";
import { sortEmployees } from './sortingUtils';

const baseHeaderStyle = {
  backgroundColor: "#EAEEFF",
  color: "black",
  borderRight: "1px solid #d9d9d9",
  fontWeight: "bold",
};
const SummaryUnassign = ({ basicDetails = {}, employees = [], assignDate, mode, onClose, scheduleOverridePermission, onRefresh }) => {
 const [form] = Form.useForm();
  const [workRule, setWorkRule] = useState([]); // <-- state for Work Rule dropdown
  const [assignEmployeeList, setAssignEmployeeList] = useState([]);
  const [payScale, setPayscale] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState('basicDetails'); // 'basicDetails' or 'assignEmployee'
  const [stepperInitialValues, setStepperInitialValues] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [date, setDate] = useState(dayjs().add(1, 'day'));
  // const [sortConfig, setSortConfig] = useState(null);
      const [sortConfig, setSortConfig] = useState({ field: "name", order: "ascend" });
  
  const originalTableData = React.useRef([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false)
  const [conflictResponse, setConflictResponse] = useState(null);
  const [time, setTime] = useState(null);
  const [payloadForReplace, setPayloadForReplace] = useState(null);
  const { userConfig } = useAuth();
  const [canEditCrew, setCanEditCrew] = useState(false);
  const [canEditSchedule, setCanEditSchedule] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const getCrewManagementPermission = () => {
    if (!permissions || !Array.isArray(permissions)) return null;
    return permissions.find((p) => p.feature === "Crew & Schedule Management");
  };
  const crewPerm = getCrewManagementPermission();
  const CrewAcees = crewPerm?.subFeatures?.find(
    (sf) => sf.name === "Crew Management"
  );
const canEditRow = (row) => {
    if (CrewAcees?.edit === "None") return false;

    if (CrewAcees?.edit === "All") return true;

    if (CrewAcees?.edit === "Myself") {
      return userConfig.userid === row.crewOwnerId;
    }

    return false;
  };
const editCondition = (CrewAcees) => {
    if (CrewAcees?.edit === "None") {
      return false;
    }

    if (CrewAcees?.edit === "All") {
      return true;
    }

    if (CrewAcees?.edit === "Myself") {
      return userConfig.userid === basicDetails.crewOwnerId;
    }
  }
const editConditionSchedule = (CrewAcees) => {
    if (CrewAcees?.edit === "None") {
      return false;
    }

    if (CrewAcees?.edit === "All") {
      return true;
    }

    if (CrewAcees?.edit === "Myself") {
      return userConfig.userid === basicDetails.crewOwnerId;
    }
  }
const handleSort = (field, order) => {
    if (!order) {
      setTableData([...originalTableData.current]);
      setSortConfig(null);
      return;
    }
   const sorted = [...tableData].sort((a, b) => {
      let aVal = a[field];
      let bVal = b[field];
    if (aVal == null && bVal == null) return 0;
      if (aVal == null) return order === 'ascend' ? 1 : -1;
      if (bVal == null) return order === 'ascend' ? -1 : 1;
      const aNum = Number(aVal);
      const bNum = Number(bVal);
      const isANumeric = !isNaN(aNum) && aVal !== '' && aVal !== null;
      const isBNumeric = !isNaN(bNum) && bVal !== '' && bVal !== null;
      if (isANumeric && isBNumeric) {
        return order === 'ascend' ? aNum - bNum : bNum - aNum;
      }
      aVal = String(aVal).toLowerCase();
      bVal = String(bVal).toLowerCase();
       if (order === 'ascend') {
        return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
      } else {
        return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
      }
    });
    setTableData(sorted);
    setSortConfig({ field, order });
  };

   const applyDefaultEmployeeSort = (rawData) => {

  // Ensure rawData is always an array
  if (!Array.isArray(rawData)) {
    return [];
  }

  return [...rawData].sort((a, b) => {
    const lastCompare = (a.lastName || '').localeCompare(
      b.lastName || '',
      undefined,
      { sensitivity: 'base' }
    );

    if (lastCompare !== 0) {
      return lastCompare;
    }

    return (a.firstName || '').localeCompare(
      b.firstName || '',
      undefined,
      { sensitivity: 'base' }
    );
  });
};
  const getEmployeeColumns = HOC('employee', { crewSchedulingPermissions: permissions, date: assignDate, crewId: basicDetails?._id, onSort: handleSort, sortConfig });

  const [tablePageSize, setTablePageSize] = useState(100);

  useEffect(() => {
    const key = userConfig?.userid ? `employee-table-page-size-${userConfig.userid}` : null;
    if (!key || typeof window === "undefined") return;
    const stored = window.localStorage.getItem(key);
    const parsed = stored ? parseInt(stored, 10) : NaN;
    if (Number.isFinite(parsed) && parsed > 0) {
      setTablePageSize(parsed);
    }
  });

  const fetchWorkRule = async () => {
    const Response = await fieldAutoSuggest({ parameter: "workRule", })
    setWorkRule(Response?.data?.workRule.map(item => item.name));
  }
  const employeeColumns = getEmployeeColumns.map(col => ({
    ...col,
    onHeaderCell: () => ({
      style: baseHeaderStyle,
    }),
  }));

  // useEffect(() => {
  //   const idMap = {};
  //   (assignEmployeeList || []).forEach(a => {
  //     if (a.employeeId) idMap[a.employeeId] = a._id;
  //   });
  //  const mappedData = (employees || []).map(emp => ({
  //     ...emp,
  //     _id: idMap[emp.id] || emp._id, // Attach _id from assignment if available
  //     scheduleIn: emp.scheduleIn || (basicDetails.startTime && dayjs.isDayjs(basicDetails.startTime) ? basicDetails.startTime.format('HH:mm') : basicDetails.startTime || ''),
  //     scheduleOut: emp.scheduleOut || (basicDetails.endTime && dayjs.isDayjs(basicDetails.endTime) ? basicDetails.endTime.format('HH:mm') : basicDetails.endTime || ''),

  //   }));
  //    const sortByLastName = (a, b) => {
  //     const lastNameA = (a.lastName || '').toLowerCase();
  //     const lastNameB = (b.lastName || '').toLowerCase();
  //     return lastNameA.localeCompare(lastNameB);
  //   };
  //   const sortedEmployees = mappedData.sort(sortByLastName);
  //   setTableData(sortedEmployees);
  //   originalTableData.current = mappedData;
  // }, [employees, basicDetails, assignEmployeeList]);

  useEffect(() => {
  const idMap = {};

  // Create employeeId → _id map
  (assignEmployeeList || []).forEach(a => {
    if (a.employeeId) {
      idMap[a.employeeId] = a._id;
    }
  });

  // Map employees with defaults
  const mappedData = (employees || []).map(emp => ({
    ...emp,

    // Attach _id from assignment if available
    _id: idMap[emp.id] || emp._id,

    scheduleIn:
      emp.scheduleIn ||
      (basicDetails.startTime && dayjs.isDayjs(basicDetails.startTime)
        ? basicDetails.startTime.format('HH:mm')
        : basicDetails.startTime || ''),

    scheduleOut:
      emp.scheduleOut ||
      (basicDetails.endTime && dayjs.isDayjs(basicDetails.endTime)
        ? basicDetails.endTime.format('HH:mm')
        : basicDetails.endTime || ''),
  }));

  // Use reusable default sorting function
  const sortedData = applyDefaultEmployeeSort(mappedData);

  setTableData(sortedData);

  // Store sorted version (fixes hidden bug)
  originalTableData.current = sortedData;

}, [employees, basicDetails, assignEmployeeList]);
  useEffect(() => {
    getRolePermissionDetails();
  }, [])
const getRolePermissionDetails = () => {
    getDetails(userConfig.orgId)
      .then((response) => {
        const fetchRole = response.data.find((role) =>
          role?.selectedRole?.toLowerCase().trim() === userConfig.role?.toLowerCase().trim() &&
          role?.selectedRoleType?.toLowerCase().trim() === userConfig.roleName?.selectedRoleType?.toLowerCase().trim()
        );
        const crewPermissions = fetchRole.permissions.cap.crewScheduling;
        setPermissions(crewPermissions);
        const crewPerm = crewPermissions?.find((p) => p?.feature === "Crew & Schedule Management");
        const CrewAcees = crewPerm?.subFeatures?.find((sf) => sf.name === "Crew Management");
        const CrewAceesSchedule = crewPerm?.subFeatures?.find((sf) => sf.name === "Schedule Management");
        const canEdit = editCondition(CrewAcees);
        const canEditSchedule = editConditionSchedule(CrewAceesSchedule);
        setCanEditCrew(canEdit);
        setCanEditSchedule(canEditSchedule);
      })
      .catch((err) => {
        console.error(err);
      })
  }
useEffect(() => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  }, [basicDetails._id]);
const [isUpdatingEdit, setIsUpdatingEdit] = useState(false);
const onFinish = async (values) => {
    if (isUpdatingEdit) return;
    setIsUpdatingEdit(true);
    setIsLoading(true);
    setIsDisabled(true)
    try {
      if (!selectedRows || selectedRows.length === 0) {
        message.warning("Please select at least one employee!");
        return;
      }
      const allowedRows = selectedRows;
      const isSingle = allowedRows.length === 1;
     //payload fields
      // const newStart = values?.scheduleIn && dayjs(values.scheduleIn).format("HH:mm") || undefined
      // const newEnd = values?.scheduleOut && dayjs(values.scheduleOut).format("HH:mm") || undefined
      const newStart =
        values?.scheduleIn
          ? dayjs(values.scheduleIn).format("HH:mm")
          : isSingle
          ? allowedRows[0]?.start
          : undefined;
      
      const newEnd =
        values?.scheduleOut
        ? dayjs(values.scheduleOut).format("HH:mm")
        : isSingle
        ? allowedRows[0]?.end
        : undefined;
      const newTask = values?.task
      const newTaskDescription = values?.taskDescription
      const newPremium =
        values?.premium !== undefined
          ? values?.premium == 'Clear'
            ? ''
            : values?.premium
          : isSingle
            ? ""
            : undefined
      const newPremiumDescription =
        values?.premiumDescription !== undefined
          ? values?.premiumDescription == 'Clear'
            ? ''
            : values?.premiumDescription
          : isSingle
            ? ""
            : undefined
      const newPayScale =
        values?.payScale !== undefined
          ? values?.payScale == 'Clear'
            ? ''
            : values.payScale
          : isSingle
            ? ""
            : undefined
      const newPayScaleDescription =
        values?.payscaleDescription !== undefined
          ? (values?.payscaleDescription === 'Clear'
            ? ''
            : values?.payscaleDescription)
          : (
            isSingle
              ? (!values?.payScale || values?.payScale === undefined)
                ? ""
                : undefined
              : (!values?.payScale == "" || values?.payScale === undefined)
                ? undefined
                : undefined
          )
      const newWorkruleTransfer =
        values?.workRuleTransfer !== undefined
          ? values?.workRuleTransfer == 'Clear' ? '' : values?.workRuleTransfer
          : isSingle
            ? ""
            : undefined

      const scheduleUpdates = {
        start: newStart,
        end: newEnd,
        date: basicDetails?.date ? dayjs(basicDetails?.date).format("YYYY-MM-DD") : undefined,
        task: newTask,
        taskDescription: newTaskDescription,
        premium: newPremium,
        premiumDescription: newPremiumDescription,
        payScale: newPayScale,
        payscaleDescription: newPayScaleDescription,
        workRuleTransfer: newWorkruleTransfer,
      };
      setTime({
    scheduleIn: values?.scheduleIn
      ? dayjs(values.scheduleIn).format("HH:mm")
      : null,
    scheduleOut: values?.scheduleOut
      ? dayjs(values.scheduleOut).format("HH:mm")
      : null,
  });
      // ✅ SAFE scheduleUpdates (NO truthy checks)
      //   const scheduleUpdates = {
      //     ...(values?.scheduleIn && {
      //           start: dayjs(values.scheduleIn).format("HH:mm"),
      //         }),
      //         ...(values?.scheduleOut && {
      //           end: dayjs(values.scheduleOut).format("HH:mm"),
      //         }),

      //     date: basicDetails?.date ? dayjs(basicDetails?.date).format("YYYY-MM-DD") : undefined,

      //     // task:
      //     //   values.task !== undefined
      //     //     ? values.task
      //     //     : isSingle
      //     //     ? ""
      //     //     : undefined,

      //     // taskDescription:
      //     //   values.taskDescription !== undefined
      //     //     ? values.taskDescription
      //     //     : isSingle
      //     //     ? ""
      //     //     : undefined,
      //     ...(values?.task && { task: values.task }),
      //     ...(values?.taskDescription && { taskDescription: values.taskDescription }),

      //     premium:
      //       values?.premium !== undefined
      //         ? values?.premium == 'Clear' ? '' :values?.premium
      //         : isSingle
      //         ? ""
      //         : undefined,

      //     premiumDescription:
      //       values?.premiumDescription !== undefined
      //         ? values?.premiumDescription == 'Clear' ? '' :values?.premiumDescription
      //         : isSingle
      //         ? ""
      //         : undefined,

      //     payScale:
      //       values?.payScale !== undefined
      //         ? values?.payScale == 'Clear' ? '' :values.payScale
      //         : isSingle
      //         ? ""
      //         : undefined,

      //     payscale:
      //       values?.payScale !== undefined
      //         ? values?.payScale == 'Clear' ? '' :values?.payScale
      //         : isSingle
      //         ? ""
      //         : undefined,

      //     // payscaleDescription:
      //     //   values.payscaleDescription !== undefined
      //     //     ? values.payscaleDescription == 'Clear' ? '' :values.payscaleDescription
      //     //     : isSingle
      //     //     ? ""
      //     //     : undefined,
      //     // payscaleDescription:
      //     //   values.payscaleDescription !== undefined
      //     //     ? values.payscaleDescription == 'Clear' ? '' :values.payscaleDescription
      //     //     : isSingle && values?.payScale === ""
      //     //     ? ""
      //     //     : undefined,
      // //     payscaleDescription:
      // // values.payscaleDescription !== undefined
      // //   ? values.payscaleDescription == 'Clear' ? '' : values.payscaleDescription
      // //   : (!values.payScale || values.payScale == undefined)
      // //   ? ""
      // //   : undefined,
      // payscaleDescription:
      // values?.payscaleDescription !== undefined
      //   ? (values?.payscaleDescription === 'Clear'
      //       ? ''
      //       : values?.payscaleDescription)
      //   : (
      //       isSingle
      //         ? (!values?.payScale  || values?.payScale === undefined)
      //           ? ""
      //           : undefined
      //         : (!values?.payScale == "" || values?.payScale === undefined)
      //           ? undefined
      //           : undefined
      //     ),

      //     workRuleTransfer:
      //       values?.workRuleTransfer !== undefined
      //         ? values?.workRuleTransfer == 'Clear' ? '' :values?.workRuleTransfer
      //         : isSingle
      //         ? ""
      //         : undefined,
      //   };

      const payload = {
        crews: [
          {
            crewId:
              allowedRows[0]?.crewId ||
              allowedRows[0]?.crew ||
              allowedRows[0]?._id,

            employeeScheduleUpdates: {
              scheduleList: allowedRows.map((row) => ({ id: row._id })),
              scheduleListEmployeeIds: allowedRows.map((row) => ({
                employeeId: row.employeeId,
              })),
              scheduleUpdates,
            },
          },
        ],
      };


      // ✅ Update DB
      const reply = await updateCrewAndEmployeeDetails(payload);
      const response = reply?.data ?? reply;

      setConflictResponse(response);

      const conflictIds =
        response?.conflictingEmployees?.map((emp) => emp.id) || [];

      const validAllowedRows = allowedRows.filter(
        (row) =>
          !conflictIds.includes(row.id) &&
          !conflictIds.includes(row.employeeId)
      );

      if (validAllowedRows.length === 0) {
        setEditModalOpen(false);
        return;
      }

      // ✅ UKG Payload (SAFE)
      const mapToPayload = (row) => ({
        id: row?.id || row?.employeeId,
        shiftId: row?.shiftId,
        workRuleTransfer: values?.workRuleTransfer ? values.workRuleTransfer == 'Clear' ? '' : values.workRuleTransfer : isSingle ? "" : row?.workRuleTransfer,
        payscale: values?.payScale ? values.payScale == 'Clear' ? '' : values.payScale : isSingle ? "" : (row?.payScale ?? row?.payscale),
        // task: values?.task ? values.task : isSingle ? "" : row?.task,
        task: values?.task ? values?.task : row?.task,
        wbsIo: basicDetails?.eventName,
        premium: values?.premium ? values.premium == 'Clear' ? '' : values.premium : isSingle ? "" : row?.premium,
        scheduleIn: values?.scheduleIn ? dayjs(values?.scheduleIn).format('HH:mm') : row?.start,
        scheduleOut: values?.scheduleOut ? dayjs(values?.scheduleOut).format('HH:mm') : row?.end,
        assignDate: dayjs(basicDetails?.date).format('YYYY-MM-DD'),
        // startTime: row?.start,
        // endTime: row?.end,
        startTime: isSingle ? row?.start
          : values.scheduleIn ?
            dayjs(values.scheduleIn).format("HH:mm")
            : row?.start,

        endTime: isSingle ? row?.end
          : values.scheduleOut ?
            dayjs(values.scheduleOut).format("HH:mm")
            : row?.end,

      });
   const payloadUKg = validAllowedRows.map(mapToPayload);
   try {
        await replaceScheduleWorkmen(payloadUKg);
      } catch (err) {
        console.error("Error in replaceScheduleWorkmen:", err);
      }
    message.success("Selected employees updated successfully!");
    setEditModalOpen(false);
      setSelectedRowKeys([]);
      setSelectedRows([]);
      if (onRefresh) await onRefresh();

    } catch (err) {
      console.error("onFinish error:", err);
      message.error("Failed to update employee schedules");
    } finally {
      setIsUpdatingEdit(false);
      setIsDisabled(false)
      setIsLoading(false);
    }
  };

 
const handleFormChange = () => {
    const values = form.getFieldsValue();
    const editableFields = ["task", "premium", "payScale", "scheduleIn", "scheduleOut", "workRuleTransfer"];
    const filled = editableFields.some((key) => values[key] !== undefined && values[key] !== null);
    setIsDisabled(!filled);
  }


  useEffect(() => {
    if (!editModalOpen) return;

    if (selectedRows?.length === 1) {
      const row = selectedRows[0];

      form.setFieldsValue({
        task: row?.task ?? undefined,
        premium: row?.premium ?? undefined,
        payScale: row?.payScale ?? row?.payscale ?? undefined,
        // scheduleIn: ( row?.start || row.scheduleIn )
        //   ? dayjs( row?.start || row.scheduleIn, "HH:mm")
        //   : null,
        // scheduleOut: ( row?.end || row?.scheduleOut )
        //   ? dayjs( row.end || row.scheduleOut , "HH:mm")
        //   : null,
        scheduleIn: row?.start
          ? dayjs(row?.start, "HH:mm")
          : null,
        scheduleOut: (row?.end)
          ? dayjs(row.end, "HH:mm")
          : null,
        workRuleTransfer: row?.workRuleTransfer ?? undefined,
      });

      setIsDisabled(true);
    } else {
      form.resetFields();
    }

  }, [editModalOpen]); 

  const formatTime = t => {
    if (!t) return '';
    
    if (dayjs.isDayjs(t)) return t.format('HH:mm');
    if (typeof t === 'string' && t.includes('T')) {
      const parsed = dayjs(t);
      if (parsed.isValid()) return parsed.format('HH:mm');
    }
    if (typeof t === 'string' && /^\d{2}:\d{2}$/.test(t)) return t;
    const parsed = dayjs(t);
    if (parsed.isValid()) return parsed.format('HH:mm');
    return t;
  };
  const formatDate = d => {
    if (!d) return '';
    if (dayjs.isDayjs(d)) return d.format('MM-DD-YYYY');
    const parsed = dayjs(d);
    if (parsed.isValid()) return parsed.format('MM-DD-YYYY');
    return String(d);
  };
  const getRowKey = (record) => record._id || record.key || record.id;
  const makeOptions = (arr = []) =>
    arr.map((item) => {
      const name = item.name || "";
      const desc = item.description || "";
      return {
        value: name,
        name,
        description: desc,
        searchText: (name + " " + desc).toLowerCase(),
        label: (
          <Tooltip title={`${name}${desc ? " - " + desc : ""}`} overlayStyle={{ pointerEvents: "none" }} placement="right" autoAdjustOverflow>
            <div className="opt-space" style={{ display: "flex", flexDirection: "column" }}>
              <div className="opt-name" style={{ fontWeight: 600 }}>{name}</div>
              {desc ? <div className="opt-desc">{desc}</div> : null}
            </div>
          </Tooltip>
        ),
      };
    });
  const [filteredTaskOptions, setFilteredTaskOptions] = useState([]);
  const [filteredPremiumOptions, setFilteredPremiumOptions] = useState([]);
  const [filteredPayScaleOptions, setFilteredPayScaleOptions] = useState([]);
  const [filteredWorkRuleOptions, setFilteredWorkRuleOptions] = useState([]);
  const [filteredEventOptions, setFilteredEventOptions] = useState([]);
  const [taskOpen, setTaskOpen] = useState(false);
  const [premiumOpen, setPremiumOpen] = useState(false);
  const [payScaleOpen, setPayScaleOpen] = useState(false);
  const [workRuleOpen, setWorkRuleOpen] = useState(false);
  const [eventOpen, setEventOpen] = useState(false);
  const [scheduleInOpen, setScheduleInOpen] = useState(false);
  const [scheduleOutOpen, setScheduleOutOpen] = useState(false);
   const debounceTasks = useCallback(() => {
    let timer;
    return (searchText, setterFn, parameter, stateKey, done) => {
      if (timer) clearTimeout(timer);
      if (!searchText) {
        setterFn([]);
        setLoading(false);
        if (done) done([]);
        return;
      }
      setLoading(true); // ✅ start loading immediately
      timer = setTimeout(async () => {
        try {
          const { data } = await fieldAutoSuggest({
            parameter,
            searchText
          });
          const arr = data?.[stateKey] || [];
          const formatted = makeOptions(arr);
          setterFn(formatted);
          if (done) done(formatted);
        } catch (error) {
          console.error(error);
          setterFn([]);
          if (done) done([]);
        } finally {
          setLoading(false); 
        }
      }, 1000);
  };
  }, []);
// Handle time input formatting with minute validation
  const handleTimeInput = (e, fieldName, setOpenFn) => {
    const input = e.target;
    const key = e.key;
   // Only handle numeric keys
    if (!/^[0-9]$/.test(key)) return;
    e.preventDefault(); // Prevent default to control input manually
    let currentValue = input.value.replace(/[^0-9]/g, ''); // Get only digits
    const cursorPos = input.selectionStart;
    // If input is empty or selecting all
    if (!currentValue || input.selectionStart === 0 && input.selectionEnd === input.value.length) {
      currentValue = '';
    }
    const digit = key;
    // Case 1: First digit is 3-9 -> auto-format to "0X:"
    if (currentValue.length === 0 && /^[3-9]$/.test(digit)) {
      const formatted = `0${digit}:`;
      input.value = formatted;
      setTimeout(() => input.setSelectionRange(3, 3), 0);
      return;
    }
    // Case 2: First digit is 0, 1, or 2 -> allow second digit
    if (currentValue.length === 0 && /^[0-2]$/.test(digit)) {
      input.value = digit;
      return;
    }
    // Case 3: Second digit after 0 or 1 -> auto-add colon
    if (currentValue.length === 1 && /^[0-1]$/.test(currentValue)) {
      const formatted = `${currentValue}${digit}:`;
      input.value = formatted;
      setTimeout(() => input.setSelectionRange(3, 3), 0);
      return;
    }
    // Case 4: Second digit after 2 -> cap at 23 if 4-9, or allow 0-3
    if (currentValue.length === 1 && currentValue === '2') {
      if (/^[4-9]$/.test(digit)) {
        // Cap at 23
        input.value = '23:';
        setTimeout(() => input.setSelectionRange(3, 3), 0);
      } else if (/^[0-3]$/.test(digit)) {
        const formatted = `2${digit}:`;
        input.value = formatted;
        setTimeout(() => input.setSelectionRange(3, 3), 0);
      }
      return;
    }
    // Handle minute input (after colon) with validation
    if (currentValue.length >= 2 && input.value.includes(':')) {
      const parts = input.value.split(':');
      const hourPart = parts[0];
      let minutePart = (parts[1] || '').replace(/[^0-9]/g, '');
      // First minute digit: if 6-9, show error (invalid)
      if (minutePart.length === 0 && /^[6-9]$/.test(digit)) {
        message.error({ content: "Invalid Entry: Minutes cannot exceed 59", key: "invalid-time", duration: 1.5 });
        return;
      }
      // First minute digit: 0-5
      if (minutePart.length === 0 && /^[0-5]$/.test(digit)) {
        input.value = `${hourPart}:${digit}`;
        return;
      }
      // Second minute digit - validate total minutes
      if (minutePart.length === 1) {
        const firstMinuteDigit = parseInt(minutePart[0]);
        const secondMinuteDigit = parseInt(digit);
        const totalMinutes = firstMinuteDigit * 10 + secondMinuteDigit;
        // Check if minutes exceed 59
        if (totalMinutes > 59) {
          message.error({ content: "Invalid Entry: Minutes cannot exceed 59", key: "invalid-time", duration: 1.5 });
          return;
        }
        minutePart += digit;
        const timeValue = dayjs(`${hourPart}:${minutePart}`, 'HH:mm');
        if (timeValue.isValid()) {
          const currentValue = form.getFieldValue(fieldName);
          const isSameTime = currentValue && dayjs(currentValue).format('HH:mm') === timeValue.format('HH:mm');
          // Close picker first
          setOpenFn(false);
          setTimeout(() => {
            // Only update form if the time is different
            if (!isSameTime) {
              form.setFieldsValue({ [fieldName]: timeValue });
              // Re-evaluate disabled state after manual time entry
              const values = form.getFieldsValue();
              const editableFields = ["task", "premium", "payScale", "scheduleIn", "scheduleOut", "workRuleTransfer"];
              const filled = editableFields.some(key => values[key] !== undefined && values[key] !== null);
              setIsDisabled(!filled);
            }
            // Always update input display to match the current input value
            input.value = `${hourPart}:${minutePart}`;
          }, 10);
        }
        return;
      }
    }
  };
  // Create debounced handlers for each field
  const debouncedSearch = useCallback(debounceTasks(), [debounceTasks]);
  const handleTaskSearch = (searchText, done) => debouncedSearch(searchText, setFilteredTaskOptions, "task_sub_task", "task_sub_task", done);
  // const handlePremiumSearch = (searchText, done) => debouncedSearch(searchText, setFilteredPremiumOptions, "level", "level", done);
  // const handlePayScaleSearch = (searchText, done) => debouncedSearch(searchText, setFilteredPayScaleOptions, "payscale_group", "payscale_group", done);
  // const handleWorkRuleSearch = (searchText, done) => debouncedSearch(searchText, setFilteredWorkRuleOptions, "workRule", "workRule", done);
  const handleEventSearch = (searchText, done) => debouncedSearch(searchText, setFilteredEventOptions, "wbs_io", "wbs_io", done);
  const handlePremiumSearch = (searchText, done) => {
    debouncedSearch(searchText, (results) => {
      setFilteredPremiumOptions([
        { value: "__clear__", name: "Clear", label: "Clear", description: "Clear" },
        ...(results || [])
      ]);
      done && done(results);
    }, "level", "level");
  };
  const handlePayScaleSearch = (searchText, done) => {
    debouncedSearch(
      searchText,
      (results) => {
        setFilteredPayScaleOptions([
          { value: "__clear__", name: "Clear", label: "Clear", description: "Clear" },
          ...(results || [])
        ]);
        done && done(results);
      },
      "payscale_group",
      "payscale_group"
    );
  };
  const handleWorkRuleSearch = (searchText, done) => {
    debouncedSearch(
      searchText,
      (results) => {
        setFilteredWorkRuleOptions([
          { value: "Clear", name: "Clear", label: "Clear", description: "Clear" },
          ...(results || [])
        ]);
        done && done(results);
      },
      "workRule",
      "workRule"
    );
  };
 return (
    <div className="crew-summary-container">
      <div className="summary-header">
        <h2 className="summary-title">Basic Details</h2>
        <Button
          type="link"
          className="custom-action-btn"
          disabled={!canEditCrew}
          onClick={() => {
            setModalStep('basicDetails');
            setStepperInitialValues({
              ...basicDetails,
              employees: employees,
              startTime: basicDetails?.startTime
                ? dayjs(basicDetails.startTime, "HH:mm")
                : undefined,

              endTime: basicDetails?.endTime
                ? dayjs(basicDetails.endTime, "HH:mm")
                : undefined,
              // startTime: basicDetails.startTime ? dayjs(basicDetails.startTime) : undefined,
              // endTime: basicDetails.endTime ? dayjs(basicDetails.endTime) : undefined,
              date: basicDetails.date ? dayjs(basicDetails.date) : undefined,
            });
            setModalOpen(true);
          }}
        >
          Edit
        </Button>
      </div>
      <div className="summary-grid">
        {/* Crew & Supervision */}
        <div className="summary-section">
          <div className="summary-section-header">
            {/* <span role="img" aria-label="crew">&#128101;</span> Crew & Supervision */}
            <span style={{ display: "flex", alignItems: "center" }}>
              <img
                src={PeopleIcon}
                alt="location"
                style={{ width: 30, height: 22, marginRight: 6 }}
              />
              Crew & Supervision            </span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Crew Name</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.crewName}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Crew Lead</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.crewLead}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Supervisor</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.supervisor}</span>
          </div>
        </div>
        {/* Shift Date & Timing */}
        <div className="summary-section">
          <div className="summary-section-header">
            <span style={{ display: "flex", alignItems: "center" }}>
              <img
                src={TimerIcon}
                alt="location"
                style={{ width: 30, height: 22, marginRight: 6 }}
              />
              Shift Date & Timing
            </span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Date</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatDate(basicDetails?.date)}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Start Time</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatTime(basicDetails?.startTime)}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">End Time</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatTime(basicDetails?.endTime)}</span>
          </div>
        </div>
        {/* Work details */}
        <div className="summary-section">
          <div className="summary-section-header" style={{ marginTop: -10 }}>
            {/* <span role="img" aria-label="work">&#128295;</span> Work details */}
            <span style={{ display: "flex", alignItems: "center" }}>
              <img
                src={SettingIcon}
                alt="location"
                style={{ width: 30, height: 22, marginRight: 6 }}
              />
              Work details           </span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Task</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.task}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Premium</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.premiumDescription}</span>
          </div>
          {/* <div className="summary-row">
            <span className="summary-key">Event</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventName}</span>
          </div> */}
          <div className="summary-row">
            <span className="summary-key">Pay Scale</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.payscaleDescription}</span>
          </div>
          {/* <div className="summary-row">
            <span className="summary-key">Event description</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventDescription}</span>
          </div> */}
        </div>
        {/* Location & Compensation */}
        <div className="summary-section">
          <div className="summary-section-header" style={{ marginTop: -10 }}>
            {/* <span role="img" aria-label="location"></span> Location & Compensation */}
            <span style={{ display: "flex", alignItems: "center" }}>
              <img
                src={LocationIcon}
                alt="location"
                style={{ width: 30, height: 22, marginRight: 6 }}
              />
              Location & Compensation
            </span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Venue</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.venue}</span>
          </div>
          {/* <div className="summary-row">
            <span className="summary-key">Pay Scale</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.payscaleDescription}</span>
          </div> */}
          <div className="summary-row">
            <span className="summary-key">Event</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventName}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Event Description</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventDescription}</span>
          </div>
        </div>
      </div>
      <div className="assigned-employees-header">
        <span>
          Scheduled Employees
          {assignDate ? ` • ${formatDate(assignDate)}` : ""}
        </span>
        <Col flex="auto" style={{ display: "flex", justifyContent: "center" }}>
          <Row gutter={[12, 12]} justify="center" style={{ textAlign: "center" }}>
            <Col>
              <div
                style={{
                  backgroundColor: "#E3F8FF",
                  borderRadius: 6,
                  padding: "5px 8px",
                  minWidth: 130,
                }}
              >
                <span>Total Needed : </span>
                <strong>{basicDetails?.employeesNeeded}</strong>
              </div>
            </Col>
            <Col>
              <div
                style={{
                  backgroundColor: "#E3F8FF",
                  borderRadius: 6,
                  padding: "5px 8px",
                  minWidth: 160,
                }}
              >
                <span>Total Scheduled : </span>
                <strong>{tableData.length}</strong>
              </div>
            </Col>
            <Col>
              <div
                style={{
                  backgroundColor: "#E3F8FF",
                  borderRadius: 6,
                  padding: "5px 8px",
                  minWidth: 100,
                }}
              >
                <span>Total +/- : </span>
                <strong>{tableData.length - basicDetails?.employeesNeeded}</strong>
              </div>
            </Col>
          </Row>
        </Col>
        <div className="header-actions">
          <Button
            icon={<FilterOutlined />}
            className="custom-action-btn"
            style={{ marginRight: "10px" }}
            hidden={true}
          />
          <Button
            type="link"
            className="custom-action-btn"
            style={{ marginRight: "10px" }}
            disabled={!canEditSchedule}
            onClick={() => {
              setModalStep('assignEmployee');
              RemoveFilters(userConfig)
              setStepperInitialValues({
                ...basicDetails,
                employees: employees,
                startTime: basicDetails?.startTime
                  ? dayjs(basicDetails.startTime, "HH:mm")
                  : undefined,
                endTime: basicDetails?.endTime
                  ? dayjs(basicDetails.endTime, "HH:mm")
                  : undefined,
                // startTime: basicDetails.startTime ? dayjs(basicDetails.startTime) : undefined,
                // endTime: basicDetails.endTime ? dayjs(basicDetails.endTime) : undefined,
                // startTime: basicDetails.startTime,
                // endTime: basicDetails.endTime ,
                date: basicDetails.date ? dayjs(basicDetails.date) : undefined,
                employeeAssignedEdit: true, // to open assign employee step directly
                mode: 'edit',
              });
              setModalOpen(true);
            }}
          >
            Add/Remove
          </Button>
          <Button
            type="link"
            className="custom-action-btn"
            style={{ marginRight: "10px" }}
            hidden={true}
          >
            Edit Schedule
          </Button>
          <Button
            type="primary"
            disabled={selectedRows.length < 1 || !canEditSchedule} // Enable only if more than one row is selected and user can edit crew
            onClick={() => {
              setEditRow(null);
              setEditModalOpen(true);
              // fetchWorkRules();
            }}
          >
            Edit
          </Button>
        </div>
      </div>
      <SmartTable
        tableKey='unassign-summary-table'
        // columns={employeeColumns.map(col => ({
        //     ...col,
        //     width: col.width || 200, // set a reasonable width
        //   }))}
        columns={employeeColumns}
        dataSource={tableData}
        pagination={{
          pageSize: tablePageSize,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={(pagination, filters, sorter, extra) => {
          if (pagination && pagination.pageSize) {
            setTablePageSize(pagination.pageSize);
            const key = userConfig?.userid ? `employee-table-page-size-${userConfig.userid}` : null;
            if (key && typeof window !== "undefined") {
              window.localStorage.setItem(key, String(pagination.pageSize));
            }
          }
        }}
        // scroll={{ x: 'max-content' }}
        scroll={tableData?.length ? { x: "100%", y: 455 } : { y: 455 }}
        bordered
        className="crew-summary-table"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys,
          preserveSelectedRowKeys: true,
          onChange: (keys) => {
            // keys represents the current selection state (what is selected now)
            // Use keys directly - no need to merge with old selection
            setSelectedRowKeys(keys);

            // Rebuild selectedRows from the full, unfiltered tableData
            const lookup = new Map((tableData || []).map(item => [getRowKey(item), item]));
            setSelectedRows(keys.map(k => lookup.get(k)).filter(Boolean));
          },
        }}
        onRow={(record) => ({
        })}
        rowKey={getRowKey}
      />
      <style>{`
        .crew-summary-container {
          font-family: 'Segoe UI', Arial, sans-serif;
          background: #fff;
          padding: 24px;
        }
        .summary-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
        }
        .summary-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-bottom: 24px;
        }
        // .summary-section {
        //   background: #eaf2ff;
        //   border-radius: 12px;
        //   padding: 0 0 12px 0;
        //   margin-bottom: 0;
        //   box-shadow: 0 1px 2px rgba(0,0,0,0.03);
        // }
        .summary-section {
  background: transparent;   /* no fixed background */
  border-radius: 12px;
  padding: 0 0 12px 0;
  margin-bottom: 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.03);
}
        .summary-section-header {
          background: #EAEEFF;
          font-weight: 500;
          padding: 8px 12px;
          border-radius: 5px 5px 0 0;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          font-size: 15px;
        }
        .summary-row {
          display: flex;
          align-items: center;
          background: #f8fafc;
          padding: 4px 12px;
          font-size: 14px;
          border-bottom: 1px solid #f0f0f0;
        }
        .summary-row:last-child {
          border-bottom: none;
        }
        .summary-key {
          flex: 1;
          color: #222;
          // background: #B4B4B450;
                    background: #F7F8FB;
                    border:#B4B4B4,
                    opacity: 0.3;
        }
        .summary-divider {
          width: 1px;
          height: 20px;
          background: #dbeafe;
          margin: 0 12px;
        }
        .summary-value {
          flex: 1;
          text-align: right;
          color: #222;
          font-weight: 700;
        }
        .assigned-employees-header {
          font-size: 16px;
          font-weight: 500;
          margin: 32px 0 12px 0;
        }
        .crew-summary-table .ant-table-thead > tr > th {
          background: #f5f7fa;
          font-weight: 500;
        }
        .crew-summary-table .ant-table-cell {
          font-size: 14px;
        }
        .crew-summary-table .ant-table-tbody > tr > td {
          padding: 8px 8px;
        }
          .assigned-employees-header {
  display: flex;
  justify-content: space-between; /* Left + Right */
  align-items: center;
  margin-bottom: 12px;
}
.header-actions {
  display: flex;
  align-items: center;
}
.summary-header {
  display: flex;
  justify-content: space-between; /* Title left, button right */
  align-items: center;
  margin-bottom: 12px;
}
.summary-title {
  margin: 0; /* Remove default margin */
  font-size: 18px;
  font-weight: 600;
}
.custom-action-btn {
          background: #f5faff !important;
          border: 1px solid #b6d6ff !important;
          color: #1677ff !important;
          border-radius: 6px !important;
          font-weight: 500 !important;
          transition: background 0.2s;
        }
        .custom-action-btn:hover, .custom-action-btn:focus {
          background: #e6f2ff !important;
          color: #0958d9 !important;
        }
        .custom-save-btn {
          background: #b6d6ff !important;
          border: 1px solid #b6d6ff !important;
          color: #fff !important;
          border-radius: 6px !important;
          font-weight: 500 !important;
        }
        .custom-save-btn:hover, .custom-save-btn:focus {
          background: #1677ff !important;
          color: #fff !important;
        }
      `}</style>
      <Modal
        open={modalOpen}
        onCancel={() => { setModalOpen(false); }}
        footer={null}
        width="100%"
        bodyStyle={{
          padding: 0,
          borderRadius: 16,
          overflow: 'hidden',
          background: '#f7f9fb',
          minHeight: 600,
        }}
        style={{ right: 10, left: 10 }}
        destroyOnClose
        centered
        maskClosable={false}
        keyboard={false}
      >
        <div style={{ padding: 32, background: '#fff', borderRadius: 16, minHeight: 600 }}>
          {modalStep === 'basicDetails' ? (
            <BasicDetails
              step={modalStep}
              initialValues={stepperInitialValues}
              mode="edit"
              isEmptyCrew={tableData?.length === 0}
              // mode={tableData?.length > 0 ? "edit" : "create"}
              onClose={() => { setModalOpen(false); }}
              onRefresh={onRefresh}
              assignDate={assignDate}
            />
          ) : (
            <MainStepper
              step={modalStep}
              initialValues={stepperInitialValues}
              scheduleOverridePermission={scheduleOverridePermission}
            />
          )}
        </div>
      </Modal>
      <Modal
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        footer={null}
        width={600}
        centered
        maskClosable={false}
        keyboard={false}
      >
          <Spin spinning={loading} tip="Loading..." size="large">
        <Form layout="vertical" onFinish={onFinish} form={form} onValuesChange={handleFormChange} >
          <h2 style={{ marginBottom: 24 }}>Edit</h2>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Task" name="task" >
                <Select
                  showArrow={false}
                  showSearch
                  placeholder="Enter Task"
                  disabled={mode === "edit"}
                  onInputKeyDown={(e) => { if (e.key === " " && e.target.value.length === 0) e.preventDefault(); }}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ width: 300, fontSize: 14 }}
                  notFoundContent={filteredTaskOptions.length === 0 && form.getFieldValue("task") !== undefined ? "No data" : null}
                  open={taskOpen}
                  onDropdownVisibleChange={(isOpen) => { if (!isOpen || filteredTaskOptions.length < 0) { setFilteredTaskOptions([]); setTaskOpen(false); } }
                  }
                  onBlur={() => {
                    const name = form.getFieldValue("task");
                    const desc = form.getFieldValue("taskDescription");
                    if (!name && !desc) {
                      form.setFieldsValue({ task: undefined, taskDescription: undefined });
                      setTaskOpen(false); setFilteredTaskOptions([]);
                    }
                  }}
                  onSearch={(text) => {
                    handleTaskSearch(text, (results) => {
                      if (results.length === 0 && text.trim().length > 0) {
                        message.error({ content: "No data found", key: "invalid-task", duration: 1.5 });
                      }
                    });
                    if (text && text.trim().length > 0) setTaskOpen(true);
                    else {
                      setTaskOpen(false);
                      setFilteredTaskOptions([]);
                    }
                  }}
                  allowClear
                  onChange={(val) => { if (!val) { form.setFieldsValue({ task: undefined, taskDescription: undefined }); setTaskOpen(false); setFilteredTaskOptions([]); } }}
                  filterOption={false}
                  optionLabelProp="label"
                  style={{ width: "100%" }}
                  onSelect={(value, option) => {
                    // option.props._name contains the real name
                    const name = option._name; // from your data
                    const description = option.description
                    form.setFieldsValue({ task: name });
                    form.setFieldsValue({ taskDescription: description });
                    setTaskOpen(false); setFilteredTaskOptions([]);
                  }}
                >
                  {(filteredTaskOptions || []).map((opt, i) => (
                    <Option key={`${opt.value}-${i}`} value={opt.value} _name={opt.name} label={opt.name} description={opt.description} >
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="taskDescription" hidden>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Premium" name="premium">
                <Select
                  showSearch
                  showArrow={false}
                  placeholder="Enter Premium"
                  disabled={mode === "edit"}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ width: 300, fontSize: 14 }}
                  notFoundContent={filteredPremiumOptions.length === 0 && form.getFieldValue("premium") !== undefined ? "No data" : null}
                  onInputKeyDown={(e) => { if (e.key === " " && e.target.value.length === 0) e.preventDefault(); }}
                  open={premiumOpen}
                  onDropdownVisibleChange={(isOpen) => { if (!isOpen || filteredPremiumOptions.length < 0) { setFilteredPremiumOptions([]); setPremiumOpen(false); } }}
                  onSearch={(text) => {
                    handlePremiumSearch(text, (results) => {
                      if (results.length === 0 && text.trim().length > 0) {
                        message.error({ content: "No data found", key: "invalid-task", duration: 1.5 });
                      }
                    });
                    if (text && text.trim().length > 0) setPremiumOpen(true);
                    else {
                      setPremiumOpen(false);
                      setFilteredPremiumOptions([]);
                    }
                  }}
                  onBlur={() => {
                    const name = form.getFieldValue("premium");
                    const desc = form.getFieldValue("premiumDescription");
                    if (!name && !desc) {
                      form.setFieldsValue({ premium: undefined, premiumDescription: undefined });
                      setPremiumOpen(false);
                    }
                    setFilteredPremiumOptions([]);
                  }}
                  allowClear
                  onChange={(val) => { if (!val) { form.setFieldsValue({ premium: undefined, premiumDescription: undefined }); setPremiumOpen(false); setFilteredPremiumOptions([]); } }}
                  filterOption={false}
                  optionLabelProp="label"
                  style={{ width: "100%" }}
                  onSelect={(value, option) => {
                    const name = option._name;
                    const description = option.description
                    form.setFieldsValue({ premium: name });
                    form.setFieldsValue({ premiumDescription: description });
                    setPremiumOpen(false); setFilteredPremiumOptions([]);
                  }}
                >
                  {(filteredPremiumOptions || []).map((opt, i) => (
                    <Option key={`${opt.value}-${i}`} value={opt.value} _name={opt.name} label={opt.name} description={opt.description}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="premiumDescription" hidden>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Payscale" name="payScale">
                <Select
                  showSearch
                  showArrow={false}
                  placeholder="Enter Payscale"
                  disabled={mode === "edit"}
                  onInputKeyDown={(e) => { if (e.key === " " && e.target.value.length === 0) e.preventDefault(); }}
                  onBlur={() => {
                    const name = form.getFieldValue("payScale");
                    const desc = form.getFieldValue("payscaleDescription");
                    if (!name && !desc) {
                      form.setFieldsValue({ payScale: undefined, payscaleDescription: undefined });
                      setPayScaleOpen(false);
                    }
                    setFilteredPayScaleOptions([]);
                  }}
                  onSearch={(text) => {
                    handlePayScaleSearch(text, (results) => {
                      if (results.length === 0 && text.trim().length > 0) {
                        message.error({ content: "No data found", key: "invalid-task", duration: 1.5 });
                      }
                    });
                    if (text && text.trim().length > 0) setPayScaleOpen(true);
                    else {
                      setPayScaleOpen(false);
                      setFilteredPayScaleOptions([]);
                    }
                  }}
                  open={payScaleOpen}
                  onDropdownVisibleChange={(isOpen) => { if (!isOpen || filteredPayScaleOptions.length < 0) { setFilteredPayScaleOptions([]); setPayScaleOpen(false); } }}
                  notFoundContent={filteredPayScaleOptions.length === 0 && form.getFieldValue("payScale") !== undefined ? "No data" : null}
                  allowClear
                  onChange={(val) => { if (!val) { form.setFieldsValue({ payScale: undefined, payscaleDescription: undefined }); setPayScaleOpen(false); setFilteredPayScaleOptions([]); } }}
                  filterOption={false}
                  optionLabelProp="label"
                  style={{ width: "100%" }}
                  onSelect={(value, option) => {
                    const name = option._name;
                    const description = option.description
                    form.setFieldsValue({ payScale: name });
                    form.setFieldsValue({ payscaleDescription: description });
                    setPayScaleOpen(false); setFilteredPayScaleOptions([]);
                  }}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ width: 300, fontSize: 14 }}
                >
                  {(filteredPayScaleOptions || []).map((opt, i) => (
                    <Option key={`${opt.value}-${i}`} value={opt.value} _name={opt.name} label={opt.name} description={opt.description}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="payscaleDescription" hidden>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Schedule In" name="scheduleIn">
                <TimePicker
                  format="HH:mm"
                  style={{ width: '100%' }}
                  placeholder="Select time (24hr)"
                  onChange={(val) => {
                    form.setFieldsValue({ scheduleIn: val });
                    setScheduleInOpen(false);
                  }}
                  onKeyDown={(e) => handleTimeInput(e, 'scheduleIn', setScheduleInOpen)}
                  needConfirm={false}
                  open={scheduleInOpen}
                  onOpenChange={setScheduleInOpen}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Schedule Out" name="scheduleOut">
                <TimePicker
                  format="HH:mm"
                  style={{ width: '100%' }}
                  placeholder="Select time (24hr)"
                  onChange={(val) => {
                    form.setFieldsValue({ scheduleOut: val });
                    setScheduleOutOpen(false);
                  }}
                  onKeyDown={(e) => handleTimeInput(e, 'scheduleOut', setScheduleOutOpen)}
                  needConfirm={false}
                  open={scheduleOutOpen}
                  onOpenChange={setScheduleOutOpen}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Work Rule" name="workRuleTransfer">
                <Select
                  showSearch
                  showArrow={false}
                  placeholder="Enter Work Rule"
                  disabled={mode === "edit"}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ width: 300, fontSize: 14 }}
                  onInputKeyDown={(e) => { if (e.key === " " && e.target.value.length === 0) e.preventDefault(); }}
                  onBlur={() => {
                    const name = form.getFieldValue("workRuleTransfer");
                    if (!name) {
                      form.setFieldsValue({ workRuleTransfer: undefined });
                      setWorkRuleOpen(false);
                    }
                    setFilteredWorkRuleOptions([]);
                  }}
                  onSearch={(text) => {
                    handleWorkRuleSearch(text, (results) => {
                      if (results.length === 0 && text.trim().length > 0) {
                        message.error({ content: "No data found", key: "invalid-task", duration: 1.5 });
                      }
                    });
                    if (text && text.trim().length > 0) setWorkRuleOpen(true);
                    else {
                      setWorkRuleOpen(false);
                      setFilteredWorkRuleOptions([]);
                    }
                  }}
                  open={workRuleOpen}
                  onDropdownVisibleChange={(isOpen) => { if (!isOpen || filteredWorkRuleOptions.length < 0) { setFilteredWorkRuleOptions([]); setWorkRuleOpen(false); } }}
                  allowClear
                  onChange={(val) => { if (!val) { form.setFieldsValue({ workRuleTransfer: undefined }); setWorkRuleOpen(false); setFilteredWorkRuleOptions([]); } }}
                  filterOption={false}
                  optionLabelProp="label"
                  style={{ width: "100%" }}
                  onSelect={(value) => {
                    form.setFieldsValue({ workRuleTransfer: value });
                    setWorkRuleOpen(false); setFilteredWorkRuleOptions([]);
                  }}
                >
                  {(filteredWorkRuleOptions || []).map((opt, i) => (
                    <Option key={`${opt.value}-${i}`} value={opt.value} _name={opt.name} label={opt.name}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <div style={{ textAlign: 'right', marginTop: 32 }}>
            <Button style={{ marginRight: 8 }} onClick={() => setEditModalOpen(false)}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" disabled={isDisabled}>
               {isLoading ? <Spin size="small" /> : "Update"}
            </Button>
          </div>
          </Form>
          </Spin>
      </Modal>
      <>
        <ScheduleConflictHandler
          response={conflictResponse}
          crew={selectedRows}
          // onOverride={handleOverride}
          values={time}
          payloadForReplace={payloadForReplace}
          scheduleOverridePermission={scheduleOverridePermission}
        />
      </>
    </div>
  );
};

export default SummaryUnassign;